import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout.jsx';
import Dashboard   from './pages/Dashboard.jsx';
import Production  from './pages/Production.jsx';
import Stock       from './pages/Stock.jsx';
import Clients     from './pages/Clients.jsx';
import OwnBrand    from './pages/OwnBrand.jsx';
import ProductSpecs from './pages/ProductSpecs.jsx';
import Outlets     from './pages/Outlets.jsx';
import Hmrc        from './pages/Hmrc.jsx';
import Casks       from './pages/Casks.jsx';
import Quotes      from './pages/Quotes.jsx';
import RecipeDev   from './pages/RecipeDev.jsx';
import Recipes     from './pages/Recipes.jsx';
import Orders       from './pages/Orders.jsx';
import StorageUnits from './pages/StorageUnits.jsx';
import Warehouse    from './pages/Warehouse.jsx';
import StockTake    from './pages/StockTake.jsx';
import Billing      from './pages/Billing.jsx';
import Salsa       from './pages/Salsa.jsx';
import Reports     from './pages/Reports.jsx';
import Settings    from './pages/Settings.jsx';
import StaffTasks  from './pages/StaffTasks.jsx';
import ProductionSchedule from './pages/ProductionSchedule.jsx';
import Calculators from './pages/Calculators.jsx';
import Help        from './pages/Help.jsx';
import Login           from './pages/Login.jsx';
import OutletRegister  from './pages/OutletRegister.jsx';
import GoodsIntakeForm from './pages/GoodsIntakeForm.jsx';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('pld_token');
  const loc = useLocation();
  // Remember where they were going (e.g. a copied recipe link) for after login.
  const next = loc.pathname + loc.search;
  return token ? children : <Navigate to={next && next !== '/' ? `/login?next=${encodeURIComponent(next)}` : '/login'} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/outlet-register" element={<OutletRegister />} />
        <Route path="/goods-intake/:token" element={<GoodsIntakeForm />} />
        <Route path="/goods-intake" element={<GoodsIntakeForm />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }
        >
          <Route index         element={<Dashboard />} />
          <Route path="production" element={<Production />} />
          <Route path="stock"      element={<Stock />} />
          <Route path="casks"           element={<Casks />} />
          <Route path="storage-units"   element={<StorageUnits />} />
          <Route path="warehouse"       element={<Warehouse />} />
          <Route path="stock-take"      element={<StockTake />} />
          <Route path="staff-tasks"    element={<StaffTasks />} />
          <Route path="production-schedule" element={<ProductionSchedule />} />
          <Route path="calculators"     element={<Calculators />} />
          <Route path="billing"         element={<Billing />} />
          <Route path="clients"    element={<Clients />} />
          <Route path="own-brand"      element={<OwnBrand />} />
          <Route path="orders"         element={<Orders />} />
          <Route path="sales-orders"   element={<Navigate to="/orders" replace />} />
          <Route path="fulfilment"     element={<Navigate to="/orders" replace />} />
          <Route path="quotes"         element={<Quotes />} />
          <Route path="recipes"        element={<Recipes />} />
          <Route path="recipe-dev"     element={<RecipeDev />} />
          <Route path="product-specs"  element={<ProductSpecs />} />
          <Route path="outlets"    element={<Outlets />} />
          <Route path="hmrc"       element={<Hmrc />} />
          <Route path="salsa"      element={<Salsa />} />
          <Route path="reports"    element={<Reports />} />
          <Route path="settings"   element={<Settings />} />
          <Route path="help"       element={<Help />} />
          {/* Fallback */}
              <Route path="*"          element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
